import React, { Component } from 'react';

class About extends Component {
  render(){

    return(
      
      <div className="general-content">
        <h2 className="content-headline no-margin">What and Where</h2>

        <section className="content-block">
          <h3 className="content-heading no-margin">About Andy</h3>
          <p>Andy Yeo sings a well-rounded mix of artists in pubs and local venues around Essex and London.</p>
        </section>

        <section className="content-block">
          <h3 className="content-heading no-margin">What does he sing?</h3>
          <p>Artists Andy covers include David Bowie, Elvis Presley, Prince, Bryan Ferry, U2, and the Rolling Stones. Music styles include classic rock, alternative rock, blues, and reggae.</p>
        </section>

        <section className="content-block">
          <h3 className="content-heading no-margin">Where does he sing?</h3>
          <p>Andy is available to do gigs in Canvey Island and surrounding areas in Essex including Benfleet, Leigh-on-sea and Southend.</p>

        </section>

      </div>
    );
  }
}
export default About;


// WEBPACK FOOTER //
// ./src/modules/pages/About.js